export const EXCLUDE_FROM_SENTRY = Symbol.for(
  'ExpectedErrorDoesNotLogToSentry',
);
